/**
 * Canonical horizontal position values for the OMQ chatbot widget.
 * Vertical anchor is always "bottom".
 */
export type ChatbotPosition = 'right' | 'center' | 'left';

/**
 * Accepted input values for the chatbot position. Includes:
 *   - canonical: 'right' | 'center' | 'left'
 *   - legacy aliases: 'bottom-right' | 'bottom-left'
 *   - backend uppercase: 'RIGHT' | 'CENTER' | 'LEFT'
 */
export type ChatbotPositionInput =
  | ChatbotPosition
  | 'bottom-right'
  | 'bottom-left'
  | 'RIGHT'
  | 'CENTER'
  | 'LEFT';

const LEGACY_MAP: Record<string, ChatbotPosition> = {
  'right': 'right',
  'center': 'center',
  'left': 'left',
  'bottom-right': 'right',
  'bottom-left': 'left',
  'RIGHT': 'right',
  'CENTER': 'center',
  'LEFT': 'left',
};

/**
 * Normalizes a chatbot position value to the canonical vocabulary.
 *
 * Returns `undefined` for null / undefined / unknown inputs so callers can
 * distinguish "not set" from "explicitly set to a valid value".
 *
 * @param value any input value
 * @returns canonical position, or undefined if unrecognized
 */
export function normalizeChatbotPosition(
  value: string | null | undefined,
): ChatbotPosition | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  return LEGACY_MAP[value];
}
